import React from 'react';
import './Loading.css';

export default class Loading extends React.Component {
  render() {
    return (
      <div className="spinner"></div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/module/Loading.js